/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DanceActivityItem } from './DanceActivityItem';
import {
    DanceActivityItemFromJSON,
    DanceActivityItemFromJSONTyped,
    DanceActivityItemToJSON,
    DanceActivityItemToJSONTyped,
} from './DanceActivityItem';

/**
 * 
 * @export
 * @interface ResultOfIReadOnlyListOfDanceActivityItem
 */
export interface ResultOfIReadOnlyListOfDanceActivityItem {
    /**
     * 
     * @type {Array<DanceActivityItem>}
     * @memberof ResultOfIReadOnlyListOfDanceActivityItem
     */
    data: Array<DanceActivityItem> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResultOfIReadOnlyListOfDanceActivityItem
     */
    isSuccess: boolean;
    /**
     * 
     * @type {Error}
     * @memberof ResultOfIReadOnlyListOfDanceActivityItem
     */
    error: Error | null;
}

/**
 * Check if a given object implements the ResultOfIReadOnlyListOfDanceActivityItem interface.
 */
export function instanceOfResultOfIReadOnlyListOfDanceActivityItem(value: object): value is ResultOfIReadOnlyListOfDanceActivityItem {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('isSuccess' in value) || value['isSuccess'] === undefined) return false;
    if (!('error' in value) || value['error'] === undefined) return false;
    return true;
}

export function ResultOfIReadOnlyListOfDanceActivityItemFromJSON(json: any): ResultOfIReadOnlyListOfDanceActivityItem {
    return ResultOfIReadOnlyListOfDanceActivityItemFromJSONTyped(json, false);
}

export function ResultOfIReadOnlyListOfDanceActivityItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfIReadOnlyListOfDanceActivityItem {
    if (json == null) {
        return json;
    }
    return {
        
        'data': (json['data'] == null ? null : (json['data'] as Array<any>).map(DanceActivityItemFromJSON)),
        'isSuccess': json['isSuccess'],
        'error': json['error'],
    };
}

export function ResultOfIReadOnlyListOfDanceActivityItemToJSON(json: any): ResultOfIReadOnlyListOfDanceActivityItem {
    return ResultOfIReadOnlyListOfDanceActivityItemToJSONTyped(json, false);
}

export function ResultOfIReadOnlyListOfDanceActivityItemToJSONTyped(value?: ResultOfIReadOnlyListOfDanceActivityItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': (value['data'] == null ? null : (value['data'] as Array<any>).map(DanceActivityItemToJSON)),
        'isSuccess': value['isSuccess'],
        'error': value['error'],
    };
}

